import {
  Input as ReactAriaInput,
  Label as ReactAriaLabel,
  NumberField as ReactAriaNumberField,
  type NumberFieldProps as ReactAriaNumberFieldProps,
} from 'react-aria-components/NumberField';

import css from './NumberField.css';

interface NumberFieldProps extends Pick<ReactAriaNumberFieldProps, 'maxValue' | 'minValue' | 'onChange' | 'value'> {
  label: string;
}

const NumberField = ({ label, ...props }: NumberFieldProps) => {
  return (
    <ReactAriaNumberField {...props}>
      <ReactAriaLabel>{label}</ReactAriaLabel>
      <ReactAriaInput className={css.input} />
    </ReactAriaNumberField>
  );
};

export default NumberField;
